module.exports = __webpack_public_path__ + "static/media/9.131cc8b4.jpg";